module.exports = __webpack_public_path__ + "img/EXPORT.72d8eea4.svg";